var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4262.000000, -498.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Transfer",
    transform: "translate(4262.000000, 498.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,14.7 L32,24 C32,27 30,29 27,29 L27,29 L0,29 L0,14.7 L16,25.7 L32,14.7 Z M16,3 L30.7,13.1 L16,23.2 L1.3,13.1 L16,3 Z M16.6,7.6 C15.4,7.6 14.4,7.9 13.7,8.4 C12.8,9.1 12.4,10 12.2,11.3 L12.2,11.3 L11.1,11.3 C10.7,11.3 10.7,11.4 10.7,11.9 L10.7002315,12.3958333 C10.7027778,12.7319444 10.7333333,12.9 11.1,12.9 L11.1,12.9 L11.1,12.8 L12.1,12.8 L12.1,13.8 L11.1,13.8 C10.7,13.8 10.7,13.9 10.7,14.4 L10.7002315,14.7958333 C10.7027778,15.1319444 10.7333333,15.3 11.1,15.3 L11.1,15.3 L12.2,15.3 L12.2,15.2 C12.4,16.3 12.8,17.1 13.3,17.6 C14,18.3 15.1,18.6 16.8,18.6 C17.6,18.6 18.8,18.5 19.5,18.1 C19.8,18 19.8,17.9 19.7,17.6 L19.7,17.6 L19.5,16.8 C19.5,16.5 19.4,16.4 19.1,16.5 C18.4,16.8 17.7,16.9 16.9,16.9 C15.9,16.9 15.4,16.7 15,16.3 C14.9,16 14.7,15.7 14.6,15.2 L14.6,15.2 L17.7,15.2 C18.1,15.2 18.1,15.1 18.1,14.6 L18.0997685,14.2041667 C18.0972222,13.8680556 18.0666667,13.7 17.7,13.7 L17.7,13.7 L14.4,13.7 L14.4,12.7 L17.7,12.7 C18.1,12.7 18.1,12.6 18.1,12.1 L18.0997685,11.6041667 C18.0972222,11.2680556 18.0666667,11.1 17.7,11.1 L17.7,11.1 L14.5,11.1 C14.6,10.4 14.7,10 15.1,9.7 C15.4,9.4 15.9,9.3 16.5,9.3 C17.4,9.3 18.2,9.5 18.8,9.9 C19,10 19.1,10 19.3,9.7 L19.3,9.7 L19.8,8.7 C19.9,8.5 19.9,8.4 19.7,8.3 C18.8,8 17.7,7.6 16.6,7.6 Z",
    id: 95
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsTransfer);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-transfer.b02697a4.svg";
export { ForwardRef as ReactComponent };